export const ENGINE_PROVENANCE = Object.freeze({
  package: "libdualnative-wasm-v1",
  version: "0.1.0-alpha.1",
  releaseTag: "v0.1.0-alpha.1",
  releaseCommit: "d986f1ab9b851dea8dd8d4a99dac6ef92acd8f25",
  archiveBytes: 277_386,
  archiveSha256:
    "70c7b254a976d919cfa37099b8ba1d9288bf9790c44b8deab614a5f7678df17d",
  packageUrl:
    "https://github.com/DualNative/libdualnative-v1/releases/download/v0.1.0-alpha.1/libdualnative-wasm-v1-0.1.0-alpha.1.tgz",
  releaseUrl:
    "https://github.com/DualNative/libdualnative-v1/releases/tag/v0.1.0-alpha.1",
  facade: "libdualnative-wasm-facade-v1",
  engine: "libdualnative-core-v1",
  domain: "libdualnative-json-merge-binary64-array-free-v1",
});

export const ENGINE_TIMEOUT_MS = 5_000;

